@import 'styles/mixins';
@import 'styles/variables';

.pill {
  white-space: nowrap;
  padding: 2px 8px;
  height: 24px;
  color: var(--pill-color);
  border-radius: 16px;
  @include md-regular;
  display: inline-flex;
  align-items: center;
  column-gap: 4px;

  // Background color
  --active: 48%;
  --hover: 49%;
  --original-color: 50%;
  --color-intensity: var(--original-color);
  background-image: linear-gradient(90deg, black, var(--pill-bg-color), white);
  background-repeat: no-repeat;
  background-size: 10000% 100%;
  background-position-x: var(--color-intensity);

  &.pressable {
    cursor: pointer;

    &:hover {
      --color-intensity: 49%;
    }

    &:active {
      --color-intensity: 48%;
    }
  }

  &.small {
    @include sm-regular;
    height: 20px;
  }
}
